import { Reveal, Eyebrow } from "./Reveal";
import { MANIFESTO, EVOLUTION, IMAGES } from "../data/content";

const StoryBanner = () => (
  <Reveal delay={0.1}>
    <div className="mt-14 relative rounded-[2rem] overflow-hidden aspect-[4/3] sm:aspect-[21/9]">
      <img
        src={IMAGES.jigsaw}
        alt="Strategy, people and execution fitting together"
        data-testid="manifesto-image"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B2A5B]/85 via-[#0B2A5B]/40 to-transparent" />
      <div className="absolute inset-0 flex items-end p-6 sm:p-8 lg:p-12">
        <p className="f-display text-white text-lg sm:text-2xl lg:text-3xl max-w-lg leading-snug">
          Synergy is Strategy, People &amp; Execution coming together — the
          whole being more than the sum total of the parts.
        </p>
      </div>
    </div>
  </Reveal>
);

const Chapters = () => (
  <div className="mt-16 lg:mt-24 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
    {MANIFESTO.map((ch, i) => (
      <Reveal key={ch.title} delay={i * 0.08} className="group border-t border-[#0B2A5B]/15 pt-8">
        <h3 className="f-display text-2xl text-[#0B2A5B]">{ch.title}</h3>
        {[].concat(ch.text).map((t) => (
          <p key={t} className="mt-4 text-[15px] leading-relaxed text-slate-600">{t}</p>
        ))}
      </Reveal>
    ))}
  </div>
);

const Evolution = () => (
  <div className="mt-24 lg:mt-32">
    <Reveal>
      <Eyebrow>Our Evolution</Eyebrow>
    </Reveal>
    <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-px bg-[#0B2A5B]/10 rounded-2xl overflow-hidden border border-[#0B2A5B]/10">
      {EVOLUTION.map((ph, i) => (
        <Reveal key={ph.phase} delay={i * 0.12} className="bg-white group hover:bg-[#0B2A5B] transition-colors duration-500 flex flex-col">
          <div className="aspect-[16/9] overflow-hidden">
            <img
              src={ph.image}
              alt={ph.title}
              data-testid={`evolution-image-${i + 1}`}
              className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105"
            />
          </div>
          <div className="p-8 lg:p-10">
            <h3 className="f-display text-xl lg:text-2xl text-[#0B2A5B] group-hover:text-white transition-colors duration-500">{ph.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 group-hover:text-white/70 transition-colors duration-500">{ph.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Our Story</Eyebrow>
        <h2 className="f-display text-4xl sm:text-5xl lg:text-[3.6rem] text-[#0B2A5B] tracking-tight mt-4 max-w-3xl leading-[1.1]">
          One journey. Thirty years.
          <br />
          <span className="italic text-[#1E5FE0]">A single lesson.</span>
        </h2>
      </Reveal>
      <StoryBanner />
      <Chapters />
      <Evolution />
    </div>
  </section>
);
